export const animations = {
  big: { spine: 'animations/spine/win/skeleton.json' },
  mega: { spine: 'animations/spine/win/skeleton.json' },
  ultra: { spine: 'animations/spine/win/skeleton.json' },
  bonusMultiplier: { spine: 'animations/spine/multiplier/skeleton.json' },
}

export const bonusMultiplierTime = 1.3
export const bigWinTime = 1
export const time = 2

export const winParticles = {
  big: [],
  ultra: ['confetti_01', 'confetti_02', 'confetti_03', 'confetti_04'],
  mega: ['confetti_01', 'confetti_02', 'confetti_03', 'confetti_04', 'dot_01'],
}

export const isNewBigWin = true
